export const envVars = process.env.REACT_APP_NODE_ENV === "production"
    ? {
        REACT_APP_NAME: "SBFHERO",
        REACT_APP_TYPE: "PROD",
        REACT_APP_DEBUG: false,
        testMode: process.env.REACT_APP_TEST_MODE === 'true',
        REACT_APP_FB_apiKey: "AIzaSyBLPORVrWAUS15PxM0SMuzHgbIfYNkYmfY",
        REACT_APP_FB_authDomain: "sbfhero-92c25.firebaseapp.com",
        REACT_APP_FB_databaseURL: "https://sbfhero-92c25-default-rtdb.asia-southeast1.firebasedatabase.app",
        REACT_APP_FB_projectId: "sbfhero-92c25",
        REACT_APP_FB_storageBucket: "sbfhero-92c25.firebasestorage.app",
        REACT_APP_FB_messagingSenderId: "628454423491",
        REACT_APP_FB_appId: "1:628454423491:web:b30cbd5e5810ce9f9f9b76",
        REACT_APP_FB_recaptchaSiteKey: "6LfbgfsqAAAAAKnbEZu8UEHzhl9uB6Nzicgp1Hxm",
        STRIPE_PAYMENT_LINK: "https://buy.stripe.com/eVa28Oa2heveeo8000",
        WEB_URL: "https://sbfhero.com",
        WEB_DOMAIN: "sbfhero.com",
        REACT_APP_SUPPORT_EMAIL: "support@sbfhero.com",
        REACT_APP_ADMIN_EMAIL: process.env.REACT_APP_ADMIN_EMAIL,
        originalPrice: "30.00",
        singleDashboardOption: ["Feb2026"],
        bundleDashboardOption: ["Feb2026", "Feb2027"],
        unlimitedDashboardOption: ["Unlimited"],
        singleDashboardPrice: "20.00",
        bundleDashboardPrice: "24.90",
        unlimitedDashboardPrice: "49.90"
    } : {
        REACT_APP_NAME: "SBFHERO (DEV)",
        REACT_APP_TYPE: "DEV",
        REACT_APP_DEBUG: true,
        testMode: process.env.REACT_APP_TEST_MODE === 'true',
        REACT_APP_FB_apiKey: "AIzaSyBC6imLUJy7aDu2rK6xGuHkFxuvmpEC_qA",
        REACT_APP_FB_authDomain: "sbfhero-dev.firebaseapp.com",
        REACT_APP_FB_databaseURL: "https://sbfhero-dev-default-rtdb.asia-southeast1.firebasedatabase.app",
        REACT_APP_FB_projectId: "sbfhero-dev",
        REACT_APP_FB_storageBucket: "sbfhero-dev.firebasestorage.app",
        REACT_APP_FB_messagingSenderId: "898972106359",
        REACT_APP_FB_appId: "1:898972106359:web:ea824290bf4bd3c3ce1072",
        REACT_APP_FB_recaptchaSiteKey: "6LcXhPsqAAAAAJDJPkpbpyUn2RdtJnYHeE8ZGjXw",
        STRIPE_PAYMENT_LINK: "https://buy.stripe.com/test_aEU2bT4wodmdfO89AA",
        WEB_URL: "https://sbfhero-dev.web.app",
        WEB_DOMAIN: "sbfhero-dev.web.app",
        REACT_APP_SUPPORT_EMAIL: "support@sbfhero.com",
        REACT_APP_ADMIN_EMAIL: process.env.REACT_APP_ADMIN_EMAIL,
        originalPrice: "30.00",
        singleDashboardOption: ["Feb2026"],
        bundleDashboardOption: ["Feb2026", "Feb2027"],
        unlimitedDashboardOption: ["Unlimited"],
        singleDashboardPrice: "20.00",
        bundleDashboardPrice: "24.90",
        unlimitedDashboardPrice: "49.90"
    }